import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { FormValues } from '../../MySettings.meta';
import { MarginProps } from '../../../../../theme/styledProps';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const DocumentVault = ({ formBag, ...rest }: Props) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Document Vault Notifications" />

      <Toggle {...formBag.register('emailDocumentNotificationsAsOwner')}>
        Enable Document Vault Notifications for Clients I am the Owner
      </Toggle>

      <Toggle {...formBag.register('emailDocumentNotificationsAsAdvisor')} mt="24">
        Enable Document Vault Notifications for Clients I am an Advisor
      </Toggle>
    </Box>
  );
};
